import { can, PortalPermissions } from "../../../config/permissions";
import React, {
  useCallback,
  useEffect, useMemo, useState,
} from 'react';
import { T2 } from '../../../styles/titles';
import LoadingOverlay from '../../../components/LoadingOverlay';
import { Col, Pagination, Row } from "antd";
import { BusinessForm, Container, DateView } from './styles';
import FormInput from "../../../components/Forms/Input";
import { Formik, Field, Form } from 'formik';
import DatePickerField from "../../../components/DatePicker";
import SelectField, { OptionType } from "../../../components/Select";
import { ISelectValue } from "../../../global/types";
import {
  AlignCheckbox,
  Button,
  CheckboxContainer,
  CheckboxTitle
} from "../../business/newBusiness/components/Form/style";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Toast } from "react-toastify/dist/components";
import LinkDeAssinaturaService from "../service/linkDeAssinaturaService";

interface FormValues {
  name: string;
  valueReais: string;
  dataExpiracao: Date | null;
  description: string;
  parcelas: ISelectValue | null;
  credito: boolean;
  debito: boolean;
  pagamentoUnico: boolean;
  primeiraCobranca: Date | null;
  recurringTime: number;
  periodo: ISelectValue | null;
  sales_limit: number;
  assinaturaVitalicia: boolean;
}

const CadastrarAssinaturas: React.FC = () => {
  const history = useHistory();
  const linkDeAssinaturaServices = new LinkDeAssinaturaService();
  const selectedBusiness = localStorage.getItem('selectedCompany') ? JSON.parse(localStorage.getItem('selectedCompany') as string) : null;
  const [links, setLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState(0);
  useEffect(() => {
    //@ts-ignore
    const user = JSON.parse(localStorage.getItem('userInfo'));
    setUserId(user.id);

  }, []);

  const cadastraLink = async (submit: any) => {
    try {
      setIsLoading(true);
      await linkDeAssinaturaServices.createLink(submit);
      history.push('/listar-assinaturas');
    } catch (e) {
      console.log(e)
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleSetCurrencyMask = useMemo(() => (
    e: React.FormEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    name: string,
  ): React.FormEvent<HTMLInputElement> => {
    let { value } = e.currentTarget;

    value = value.replace(/\D/g, '');
    value = value.replace(/(\d)(\d{2})$/, '$1,$2');
    value = value.replace(/(?=(\d{3})+(\D))\B/g, '.');

    e.currentTarget.value = value;
    setFieldValue(name, value);
    return e;
  }, []);


  const periodos: ISelectValue[] = [
    //{ label: 'Semana(as)', value: 'semana' },
    { label: 'Mes(es)', value: 'mes' },
    //{ label: 'Ano(s)', value: 'ano' },
  ];

  const meses: ISelectValue[] = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
    { label: '13', value: '13' },
    { label: '14', value: '14' },
    { label: '15', value: '15' },
    { label: '16', value: '16' },
    { label: '17', value: '17' },
    { label: '18', value: '18' },
    { label: '19', value: '19' },
    { label: '20', value: '20' },
    { label: '21', value: '21' },
    { label: '22', value: '22' },
    { label: '23', value: '23' },
    { label: '24', value: '24' },
  ];

  const formatDateToYYYYMMDD = (date: any) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  // start_billing da Phoebus: quantidade de dias, a partir de hoje, até a primeira cobrança.
  // As datas são normalizadas para meia-noite para que o horário atual não gere off-by-one.
  const calcularDiasAtePrimeiraCobranca = (dataCobranca: Date): number => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const cobranca = new Date(dataCobranca);
    cobranca.setHours(0, 0, 0, 0);

    return Math.round((cobranca.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));
  }

  return (
    <Container>
      <LoadingOverlay
        show={isLoading}
        relative
      />

      <T2>Cadastrar assinatura</T2>
      <Formik<FormValues>
        onSubmit={async (values: any) => {
          if (values.name == '') {
            toast.error('Nome do produto é obrigatório!')
            return
          }

          if (values.value == '') {
            toast.error('Valor é obrigatório!')
            return
          }

          if (values.dataExpiracao == null) {
            toast.error('Data de expiração é obrigatório!')
            return
          }

          if (values.description == '') {
            toast.error('Descrição é obrigatório!')
            return
          }

          if (values.recurringTime == 0 || values.recurringTime == null) {
            if (values.periodo.value != 'semana') {
              toast.error('O campo cobrar a cada é obrigatório!');
            }
            return
          }

          if (values.primeiraCobranca == null) {
            toast.error('Primeira cobrança é obrigatório!')
            return
          }

          const currentDate = new Date();
          const dayBefore = new Date(currentDate);
          dayBefore.setDate(currentDate.getDate() - 1);

          // Verifica se a data especificada é maior que a data atual
          if (values.primeiraCobranca <= dayBefore) {
            toast.error('A data da cobrança deve ser maior que a data atual.');
            return;
          }

          let recurring = { recurring_rule: "", start_billing: 0 }

          let recurring_rule = "";
          if (values.periodo == null) {
            values.periodo = { label: 'Mes(es)', value: 'mes' };
          }

          if (!values.assinaturaVitalicia && !values.sales_limit) {
            toast.error('Quantidade de Meses é obrigatório!');
            return;
          }

          // Dias da semana no formato iCalendar (RFC5545), indexados por Date.getDay()
          const diasDaSemana = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

          if (values.periodo.value == 'semana') {
            recurring_rule = `FREQ=WEEKLY;BYDAY=${diasDaSemana[values.primeiraCobranca.getDay()]};`

            // Regra de recorrência para semanal "FREQ=WEEKLY;BYDAY=MO" -> BYDAY é o dia da semana, e não o INTERVAL
          } else if (values.periodo.value == 'ano') {
            recurring_rule = `FREQ=YEARLY;INTERVAL=${values.recurringTime};`
          } else {
            recurring_rule = `FREQ=MONTHLY;INTERVAL=${values.recurringTime};`
          }

          // A regra NÃO deve conter BYMONTHDAY/BYMONTH: quando esses parâmetros estão
          // presentes a Phoebus descarta o start_billing e agenda apenas pelo dia do mês,
          // caindo sempre no mês corrente (primeira cobrança 15/10 virava 15/08).
          // Sem eles, o start_billing define a data da primeira cobrança e os ciclos
          // seguintes repetem a mesma data nos períodos subsequentes.
          recurring.start_billing = calcularDiasAtePrimeiraCobranca(values.primeiraCobranca);

          recurring.recurring_rule = recurring_rule
          values.recurring_rule = recurring_rule

          values.recurring = recurring;

          if (values.parcelas != null) {
            values.installment = {}
            values.installment.installment_limit = parseInt(values.parcelas.value)
          } else {
            values.installment = {}
            values.installment.installment_limit = 1
          }
          values.payment_methods = []
          values.payment_methods.push('CREDIT')

          if (values.payment_methods.length == 0) {
            toast.error('Selecione pelo menos uma forma de pagamento!')
            return
          }

          if (values.dataExpiracao != null) {
            values.expires_at = formatDateToYYYYMMDD(values.dataExpiracao)
          }

          if (values.pagamentoUnico) {
            values.sales_limit = 1;
          }

          values.usuario_id = userId
          const normalizedValue = values.valueReais.replace(/\./g, '').replace(',', '.');;
          const numberValue = parseFloat(normalizedValue);
          values.value = numberValue * 100

          cadastraLink(values)
        }}

        initialValues={{
          name: '',
          valueReais: '',
          dataExpiracao: null,
          description: '',
          parcelas: { label: '1', value: '1' },
          credito: false,
          debito: false,
          pagamentoUnico: false,
          primeiraCobranca: null,
          recurringTime: 1,
          periodo: { label: 'Mes(es)', value: 'mes' },
          sales_limit: 0,
          assinaturaVitalicia: false,
        }}>

        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={18} align="top" justify="start">
              <Col span={12}>
                <FormInput
                  type="text"
                  name="name"
                  label="Nome do produto"
                  required
                  placeholder="O que você está vendendo"
                />
              </Col>
              <Col span={12}>
                <FormInput
                  type="text"
                  name="valueReais"
                  label="Valor"
                  required
                  placeholder="0,00"
                  prefix="R$"
                  onChange={(e: React.FormEvent<HTMLInputElement>) => handleSetCurrencyMask(e, setFieldValue, 'valueReais')}
                />
              </Col>
            </Row>
            <Row gutter={18} align="top" justify="start">
              <Col span={12}>
                <DateView>
                  <DatePickerField
                    name="dataExpiracao"
                    label="Expira em"
                    required
                    placeholder="Data de expiração"
                  />
                </DateView>
              </Col>
              <Col span={12}>
                <FormInput
                  type="text"
                  name="description"
                  label="Descrição da assinatura"
                  required
                  placeholder="Descrição do produto ou serviço"
                />
              </Col>
            </Row>

            <Row gutter={18} align="top" justify="start">
              {values.periodo?.value != 'semana' && (
                <Col span={12}>
                  <FormInput
                    type="text"
                    name="recurringTime"
                    label="Cobrar a cada"
                    required
                    placeholder="1"
                  />
                </Col>
              )}
              <Col span={12}>
                <SelectField
                  name="periodo"
                  label="Período"
                  options={periodos}
                  placeholder=""
                />
              </Col>
            </Row>

            <Row gutter={18} align="top" justify="start">
              <Col span={12}>
                <DateView>
                  <DatePickerField
                    name="primeiraCobranca"
                    label="Primeira cobrança em"
                    required
                    placeholder="Primeira cobrança em"
                  />
                </DateView>
              </Col>
              <Col span={12}>
                <SelectField
                  name="meses"
                  label="Quantidade Mês/Ano"
                  options={meses}
                  placeholder="Quantidade máxima de meses/ano"
                  isDisabled={values.assinaturaVitalicia}
                  isClearable={true}
                  onChange={(selectedOption) => {
                    if (selectedOption && !Array.isArray(selectedOption)) {
                      const option = selectedOption as OptionType;
                      setFieldValue('sales_limit', Number(option.value));
                    } else {
                      setFieldValue('sales_limit', null);
                    }
                  }}
                />
                <CheckboxContainer>
                  <AlignCheckbox>
                    <input
                      type="checkbox"
                      id="assinaturaVitalicia"
                      checked={values.assinaturaVitalicia}
                      disabled={!!values.sales_limit && values.sales_limit > 0}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setFieldValue('assinaturaVitalicia', checked);

                        if (checked) {
                          setFieldValue('sales_limit', 0);
                        }
                      }}
                    />
                    <label htmlFor="assinaturaVitalicia" style={{ marginLeft: 10 }}>
                      Assinatura Vitalícia
                    </label>
                  </AlignCheckbox>
                </CheckboxContainer>
              </Col>
            </Row>

            <Row justify="end">
              {can(PortalPermissions.assinaturas.gerar.gerar) && (
                <Button htmlType="submit">
                  Salvar
                </Button>
              )}
            </Row>
          </Form>
        )}
      </Formik>

    </Container>
  );
}
export default CadastrarAssinaturas;
